import React from 'react';

import {
    TextField,
    makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyTextField ({ ...otherProps }) {
    const classes = useStyles();
 
    return (
        <TextField
            classes={{ root: classes.root }}
            fullWidth
            {...otherProps}
        />
    );
}

const styles = (theme) => ({
    root: {
        '& > div > input': {
            borderBottom: `2px solid ${theme.palette.primary.main} !important`,
            color: theme.palette.primary.main
        },
        '& > div::before': {
            borderBottom: `2px solid ${theme.palette.primary.main} !important`,
            transition: 'none'
        },
        '& > div::after': {
            transition: 'none'
        }
    }
});

export default AuthBodyTextField;